// Rebranding Colors
export const darkBlueCrehana = '#181B32';
export const purpleBlue = '#3417AA';
export const blueCrehana = '#4B22F4';
export const lightBlue = '#6F4EF6';

export const darkAqua = '#00AEB5';
export const aquaCrehana = '#03CAD2';
export const lightAqua = '#45DFE6';

export const darkGray = '#8D8D9D';
export const gray = '#DFE1E6';
export const gray2 = '#E8EAF0';
export const lightGray = '#F6F7F9';
export const purpleGray = '#A0A7CB';
export const white = '#FFFFFF';
export const black = '#000000';

export const red = '#FF5C63';
export const red2 = '#FF797F';
export const red3 = '#FFC3C6';
export const red4 = '#FFF0F0';

export const green = '#00DD8D';
export const green2 = '#5CE9B6';
export const green3 = '#97F1D0';
export const green4 = '#D0F8EA ';

export const yellow = '#FFD32A';
export const yellow2 = '#FFDF64';
export const yellow3 = '#FFEFB1';
export const yellow4 = '#FFF7D8 ';

export const selectActive = '#F6F4FE'; // blueCrehana opacity 0.05

// Rebranding Colors RGB equivalents
export const darkBlueCrehanaRGB = '24,27,50';
export const purpleBlueRGB = '52,23,170';
export const blueCrehanaRGB = '75,34,244';
export const lightBlueRGB = '111,78,246';

export const darkAquaRGB = '0,174,181';
export const aquaCrehanaRGB = '3,202,210';
export const lightAquaRGB = '69,223,230';

export const darkGrayRGB = '141,141,157';
export const grayRGB = '223,225,230';
export const gray2RGB = '232,234,240';
export const lightGrayRGB = '246,247,249';
export const purpleGrayRGB = '160,167,203';
export const whiteRGB = '255,255,255';
export const blackRGB = '0,0,0';

export const redRGB = '255,92,99';
export const red2RGB = '255,121,127';
export const red3RGB = '255,195,198';
export const red4RGB = '255,240,240';

export const greenRGB = '0,221,141';
export const green2RGB = '92,233,182';
export const green3RGB = '151,241,208';
export const green4RGB = '208,248,234';

export const yellowRGB = '255,211,42';
export const yellow2RGB = '248,228,120';
export const yellow3RGB = '255,239,177';
export const yellow4RGB = '248,228,120';

// Extra: Tag colors. Not in the main palette, but work both on dark and light backgrounds.
export const customPurple = '#A18AFF';
export const customOrange = '#FF8A00';
export const customCyan = '#00D1FF';
export const customBlue = '#1F6AF6';

// Previous colors

export const mainBackground = '#F7F9FB';
export const mainColor = blueCrehana; // prev: #0099FF
export const mainHover = aquaCrehana; // prev: #0066FF

export const mainColorRGB = blueCrehanaRGB; // prev: #0099FF
export const mainHoverRGB = aquaCrehanaRGB; // prev: #0066FF

export const mainLight = '#7FCBFF';

export const secondaryColor = green; // prev: #1ed760
export const secondaryHover = green2; // prev: #23E468

export const secondaryColorRGB = greenRGB; // prev: #1ed760
export const secondaryHoverRGB = green2RGB; // prev: #23E468

export const mainText = '#181b32';

export const mainTextRGB = '24,27,50';

export const secondaryText = '#181b32';
export const accentText = aquaCrehana; // prev: #0099FF
export const labelText = '#A7A7A7';
export const buttonText = '#FFFFFF';

export const error = red;
export const errorHover = red2;

export const errorRGB = redRGB;
export const errorHoverRGB = red2RGB;

export const staffLabel = customPurple;
export const professorLabel = customOrange;
export const premiumLabel = yellow;
export const plusChipBg = green2;
export const professionalChipBg = customBlue;
export const premiumChipBg = yellow;
export const mentorChipBg = customCyan;

export const selectedHeart = red2;
export const defaultHeart = '#C6C6C6';

export const blue = '#0099FF';
// export const yellow = '#DCDB63';
// export const red = '#ff3d47';
// export const white = '#FFFFFF';
export const beige = '#f7f9fd';
// export const green = '#35DF86';
export const grey = '#3A3A3A';
